/**
 * @generated SignedSource<<4f72583126453f13c39bab77e9e406af>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type portal_HelpCenterPortal$data = {
  readonly description: string | null | undefined;
  readonly logo: string | null | undefined;
  readonly name: string;
  readonly portalId: string | null | undefined;
  readonly " $fragmentType": "portal_HelpCenterPortal";
};
export type portal_HelpCenterPortal$key = {
  readonly " $data"?: portal_HelpCenterPortal$data;
  readonly " $fragmentSpreads": FragmentRefs<"portal_HelpCenterPortal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "portal_HelpCenterPortal",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "name"
      },
      "action": "THROW",
      "path": "name"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "logo"
    },
    {
      "kind": "ScalarField",
      "name": "portalId"
    }
  ],
  "type": "HelpLayoutPortalCard"
};

(node as any).hash = "3799a41c8f97aa60a39e5e30cebbea7b";

export default node;
